import React, { Component, Fragment } from 'react'
import { EmailLayoutsService } from './services';
import { HttpResponse } from '../../../../core';
import { NavLink } from "react-router-dom";
import { EmailLayoutsTabs } from './EmailLayoutsTabs'
import { DropdownItemModel } from '../../../../shared/models';
import { ButtonType } from '../../../../shared/enums/button.enum';
import { ShowSuccessMessage, HandleNotFoundResponse } from '../../../../shared/helpers';
import { NotFoundResponseArea } from '../../../../shared/enums';
import { EmailLayoutsDeleteModel, EmailLayoutsDeleteResponseModel } from './models';

interface IState {
    result?: EmailLayoutsDeleteModel;
    deleteResult?: EmailLayoutsDeleteResponseModel;
    isDoubleleClick?: boolean;
}
export class DeleteEmailLayouts extends Component<any, IState> {
    private service: EmailLayoutsService;
    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.service = new EmailLayoutsService();
        this.deleteRecord = this.deleteRecord.bind(this);
    }

    initialState: Partial<IState> = {
        result: {
            id: 0 ,  
            name: "",
            email_templates:[]
        },
        deleteResult: { isdeleted: false },
        isDoubleleClick: false  
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        this.service.getLinkedResourcesById(this.props.match.params.id)
            .then((res: HttpResponse<EmailLayoutsDeleteModel>) => {
                if (res && res.result) {
                    this.setState({
                        result: res.result
                    });
                }
            })
            .catch(ex => {
                HandleNotFoundResponse(ex,NotFoundResponseArea.EmailLayouts,this.props) 
            });
    }

    deleteRecord() {
        if (!this.state.isDoubleleClick) {
            this.setState({ isDoubleleClick: true })
            this.service.deleteRecordById(this.props.match.params.id)
                .then((res: HttpResponse<EmailLayoutsDeleteResponseModel>) => {
                    if (res && res.result) {
                     
                        this.setState({
                            deleteResult: res.result
                        }, () => {
                            if (this.state.deleteResult?.isdeleted) {
                                ShowSuccessMessage("Email Layouts Successfully deleted.");
                                this.props.history.push('/email-layout/list');
                            }
                        });
                    }
                });
        }
    }

    render() {
        return (
            <Fragment>
                {/* {this.state.result?.scheduled_reports.value == this.props.match.params.id && <div> */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5>Delete Email Layout '{this.state.result?.name}'</h5>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <EmailLayoutsTabs id={this.props.match.params.id} url="/email-layouts-/delete/" />
                                <div className="alert font-weight-bold  alert-light"> <i className="fas fa-exclamation-circle text1"></i> Are you sure you want to delete this Email Layout <strong>“ {this.state.result?.name}”</strong> ?</div>
                                <p className="mt-4 text-danger"><i className="fas fa-exclamation-triangle text1"></i> The following related items may be deleted or orphaned:</p>
                               
                               <div className="row">
                                    <div className="col">
                                        <div className="card card-primary shadow-sm">
                                            <div className="card-header">
                                             <h4>Email Templates <small></small></h4>
                                            </div>
                                            <div className="card-body">
                                                {this.state.result?.email_templates.map((item, i) => {
                                                    return(
                                                        <NavLink className="badge badge-light text-link m-1" to={"/email-template/detail/" + item.id}>{item.name} </NavLink>
                                                    )
                                                })}
                                                 {this.state.result?.email_templates.length == 0 && <span>No Email Template</span>}
                                            </div>
                                        </div>
                                    </div>
                  
                                </div>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="mx-auto">
                                <button className="btn btn-lg btn-danger" disabled={this.state.isDoubleleClick} onClick={this.deleteRecord}> {ButtonType.Delete}</button>
                                <NavLink type="button" className="btn btn-lg btn-default ml-3" to="/email-layout/list">{ButtonType.Cancel}</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div>} */}
            </Fragment>
        )
    }
}
